import moment from 'moment/moment';

const format = 'YYYY-MM-DDTHH:mm:ss[Z]';

// replaces timezone from UTC to local. Preserves all other data (year, month, etc)
export const toLocalDate = (dateTime: string | null): Date | null => {
  if (!dateTime) {
    return null;
  }

  return moment(dateTime.replace('/Z$/', ''), format).toDate();
};

// changes Date object to string and replaces local timezone to UTC
export const toUTCString = (dateTime: Date | null): string => {
  if (!dateTime) {
    return '';
  }
  return moment(dateTime).utcOffset(0, true).format(format);
};
